var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"label":_vm.copyText,"position":"is-left","square":"","size":"is-small","type":"is-dark"}},[_c('span',{on:{"click":function($event){return _vm.copy(_vm.arg)}}},[_vm._v("\n    "+_vm._s(_vm.locatorArg)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }